import React from 'react';
import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import DividerWithTitle from '../../components/DividerWithTitle';
import ButtonSecondary from '../../design/button-secondary/ButtonSecondary';
import theme from '../../styles/theme';
import coverImage from '../../assets/imgs/about_the_company_1.png';
import { CustomSvgIcon } from '../../components/ImagesComponents';
import {
  FeaturesContainer,
  FeaturesSection,
  FeatureSubtitle,
} from './components/FeatureComponents';
import { useTranslation } from 'react-i18next';

export default function LandingBriefInfo() {
  const { t } = useTranslation();

  const handleGetStarted = () => {
    const element = document.querySelector('#contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <FeaturesSection id='brief-info'>
      <DividerWithTitle
        title={t('informationServices.briefInfo.dividerTitle')}
      />
      <FeaturesContainer>
        <Box
          display='flex'
          flexDirection='column'
          rowGap={4}
          sx={{
            width: { xs: '100%', md: '400px' },
            alignItems: { xs: 'center', md: 'flex-start' },
            textAlign: { xs: 'center', md: 'left' },
          }}
        >
          <FeatureSubtitle>
            {t('informationServices.briefInfo.subtitle')}
          </FeatureSubtitle>
          <Typography
            fontWeight={300}
            color='text.primary'
            sx={{
              fontSize: { xs: '14px', md: '14px' },
              maxWidth: { xs: '100%', md: '800px' },
            }}
          >
            {t('informationServices.briefInfo.description')}
          </Typography>
          <ButtonContainer>
            <ButtonSecondary onClick={handleGetStarted}>
              {t('informationServices.briefInfo.buttonText')}
            </ButtonSecondary>
          </ButtonContainer>
        </Box>
        <ImageContainer>
          <LogoContainer>
            <CustomSvgIcon name='logomark_purple' size={180} />
          </LogoContainer>
        </ImageContainer>
      </FeaturesContainer>
    </FeaturesSection>
  );
}

const ImageContainer = styled(Box)(({ theme }) => ({
  background: `url(${coverImage})`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  height: '390px',
  width: '620px',
  marginRight: '53px',
  position: 'relative',
  [theme.breakpoints.down('md')]: {
    width: '100%',
    height: '250px',
    marginRight: '0',
    order: -1,
  },
  [theme.breakpoints.down('sm')]: {
    height: '200px',
  },
}));

const LogoContainer = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: '-30px',
  right: '-110px',
  display: 'flex',
  alignItems: 'center',
  zIndex: 1,
  [theme.breakpoints.down('md')]: {
    top: '50%',
    right: '50%',
    transform: 'translate(50%, -50%)',
  },
  [theme.breakpoints.down('sm')]: {
    '& svg': {
      width: '120px',
      height: '120px',
    },
  },
}));

const ButtonContainer = styled(Box)(() => ({
  width: '120px',
  paddingTop: theme.spacing(4),
}));
